/**
 * 2019/1/17.
 * 作者:zyc
 *功能: 系统管理-通用字典配置
 */
export default {
  $getway: 'sysapi',
  saveSysDicControllerAssessMainSave: 'SysDicController/assessMainSave',
  deleteSysDicControllerDelete: 'SysDicController/delete',
  getSysDicControllerDicCalculationDetail: 'SysDicController/dicCalculationDetail',
  getSysDicControllerDicCalculationList: 'SysDicController/dicCalculationList',
  setSysDicControllerStartUse: 'SysDicController/startUse'
};
